import React from "react";
import Swal from "sweetalert2";

const AlertBox = (title, text, type, onClickOk = null) => {
  Swal.fire({
    icon: type,
    allowOutsideClick: false,
    title,
    text,
  }).then((result) => {
    if (result.isConfirmed && onClickOk) {
      onClickOk();
    }
  });
};

export default AlertBox;
